<template>
  <modal :show="show" @close="$emit('close')" :transparent="false">
    <div class="center">
      <header class="bb b--near-white flex items-center justify-between bg-light" style="height: 60px; z-index:10;">
        <a href="#0" class="f5 no-underline dim black bg-animate inline-flex items-center pa3" @click="$emit('close')">
          <svg class="w1" data-icon="chevronLeft" viewBox="0 0 32 32" style="fill:currentcolor">
            <title>chevronLeft icon</title>
            <path d="M20 1 L24 5 L14 16 L24 27 L20 31 L6 16 z"></path>
          </svg>
        </a>
      </header>
      <div class="ma2">
        <slot></slot>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from './Modal.vue'

export default {
  components: {
    Modal
  },
  props: ['show']
}
</script>
